"use client";

import { api } from "@klarify/ui/trpc/client";
import { classifyTrafficSource } from "@klarify/utilities";
import { useEffect } from "react";
import { alreadyTrackedRecently, getOrCreateVisitorId } from "./visitor-id";

type Props = {
	clinicId: string;
	clinicSlug: string;
	postId: string;
	postSlug: string;
	category: string | null;
	wordCount: number;
};

export function TrackPostView({
	clinicId,
	clinicSlug,
	postId,
	postSlug,
	category,
	wordCount,
}: Props) {
	const track = api.trackingRouter.trackPublicPageview.useMutation();

	useEffect(() => {
		// 30-min dedup so back-nav and remounts don't inflate counts.
		if (alreadyTrackedRecently(`post:${postId}`)) {
			return;
		}
		const source = classifyTrafficSource(
			document.referrer || undefined,
			window.location.hostname,
		);
		track.mutate({
			distinctId: getOrCreateVisitorId(),
			event: "therapist_post_viewed",
			properties: {
				clinicId,
				clinicSlug,
				postId,
				postSlug,
				category,
				wordCount,
				source,
			},
		});
	}, [clinicId, clinicSlug, postId, postSlug, category, wordCount, track]);

	return null;
}
